export default "__VITE_ASSET__CFLA8kQF__"